"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ValidationOverlay: true
};
exports.default = exports.ValidationOverlay = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _Popper = require("../utils/_Popper");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _ValidationMessage = require("./_ValidationMessage");
var _ValidationOverlay = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ValidationOverlay.css") : void 0);
var _ValidationOverlay2 = require("./_ValidationOverlay.types");
Object.keys(_ValidationOverlay2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ValidationOverlay2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ValidationOverlay2[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-validation-overlay';
const ValidationOverlay = exports.ValidationOverlay = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildPropsFromContextAbove = (0, _AddChildPropsContext.useAddChildProps)();
  const liveRegionRef = (0, _react.useRef)(null);
  const props = addChildPropsFromContextAbove ? Object.assign(Object.assign({}, _props), addChildPropsFromContextAbove(ValidationOverlay, _props)) : _props;
  const {
      children,
      customLiveRegionRef,
      liveRegionClassName,
      show,
      targetClassName,
      targetProps,
      validationMessage = {},
      id
    } = props,
    otherProps = __rest(props, ["children", "customLiveRegionRef", "liveRegionClassName", "show", "targetClassName", "targetProps", "validationMessage", "id"]);
  const classnames = _bind.default.bind(_ValidationOverlay.default);
  let validationId = (0, _useUniqueId.default)();
  if (id) {
    validationId = id;
  }
  const childrenArray = _react.default.Children.toArray(children);
  // Intercept Popper's context but pass parent context through to the target
  const targetComponent = /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildPropsFromContextAbove
  }, childrenArray[0]);
  const overlayClasses = classnames(_constants.CSS_PREFIX, CSS_BLOCK);
  return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: null
  }, /*#__PURE__*/_react.default.createElement(_Popper.Popper, {
    offset: 2,
    popperClassName: overlayClasses,
    popperProps: {
      innerRef: ref,
      'aria-labelledby': validationId
    },
    show: show,
    targetClassName: targetClassName || classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__popper`),
    targetComponent: targetComponent,
    targetProps: targetProps,
    widthSizingType: "maxTarget",
    customContainer: customLiveRegionRef || liveRegionRef
  }, /*#__PURE__*/_react.default.createElement(_ValidationMessage.ValidationMessage, Object.assign({}, otherProps, {
    id: validationId,
    state: validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state,
    text: validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text
  }))), !(typeof customLiveRegionRef === 'object' && (customLiveRegionRef === null || customLiveRegionRef === void 0 ? void 0 : customLiveRegionRef.current)) && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__live-region`, liveRegionClassName),
    "data-test": "validation-status",
    "aria-live": "polite",
    role: "status",
    ref: liveRegionRef
  })));
});
ValidationOverlay.displayName = 'ValidationOverlay';
var _default = exports.default = ValidationOverlay;